import { OnInit, OnDestroy, Injectable, inject } from '@angular/core';
import { EventManager } from '../../core';
import { Subject, Subscription } from 'rxjs';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { EditComponent } from './edit.component';

@Injectable({ providedIn: 'any' })
export abstract class ModalComponent extends EditComponent implements OnInit, OnDestroy {
  subscriptions?: Subscription[] = [];
  subsCommon?: Subscription[] = [];
  callApi$ = new Subject();
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  constructor(
    public eventManager: EventManager,
    public modalRef : NzModalRef,
  ) {
    super(eventManager)
  }
  ngOnInit() {
    super.ngOnInit();
    if (this.nzModalData) {
      Object.keys(this).forEach((key) => {
        if (this.nzModalData[key] && typeof this[key] !== 'function') {
          this[key] = this.nzModalData[key];
        }
      })
    }
    
  }
  cancel() {
    this.modalRef.close();
  }
  close() {
    this.modalRef.close();
  }
  dismiss() {
    this.modalRef.close();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.cancel();
  }
}
